import styled from "styled-components"
import { Link as LinkTo } from "gatsby"

import { maxD } from "../../../assets/styles/helpers/devices"

const buttonTheme = theme => {
  switch (theme) {
    case "green":
      return "var(--main-green)"
    case "orange":
      return "var(--orange)"
    case "white":
      return "#fff"
    case "active-filter":
      return "var(--main-green)"
    default:
      return "var(--dark-gray)"
  }
}

const Button = styled(LinkTo)`
  --padding-vertical: 17px;
  --padding-horizontal: 30px;
  --border-radius: 30px;

  display: inline-flex;
  flex-shrink: 0;

  padding: var(--padding-vertical) var(--padding-horizontal);
  border-radius: var(--border-radius);

  border: 2px solid ${({ theme }) => buttonTheme(theme)};
  background-color: ${({ theme }) => (theme === "active-filter" ? "#fff" : buttonTheme(theme))};
  color: ${({ theme }) => (theme === "white" ? "var(--dark-gray)" : (theme === "active-filter" ? "var(--main-green)" : "#fff"))};
  box-shadow: ${({ theme }) => (theme === "active-filter" ? "0 4px 10px rgba(0, 0, 0, 0.41)" : "none")};

  text-align: center;
  font-size: 1rem;

  transition: color 200ms, background-color 200ms;

  &::before, &::after {
    content: "";
    position: absolute;
    width: 14px;
    height: 2px;
    top: 50%;
    right: 12px;
    transform: translateY(-50%) rotate(45deg);
    background: var(--main-green);
    transition: 0.3s ease-out;
    opacity: ${({ theme }) => (theme === "active-filter" ? "1" : "0")};
  }
  &::before {
    transform: translateY(-50%) rotate(-45deg);
  }

  @media ${maxD.mobileL} {
    display: var(--display-on-mobile, inline-flex);
  }

  &:not(disabled):hover {
    color: ${({ theme }) => buttonTheme(theme)};
    background-color: ${({ theme }) =>
      theme === "white" ? "var(--dark-gray)" : "#fff"};
  }

  @media ${maxD.desktop} {
    padding: calc(var(--padding-vertical) * 0.96)
      calc(var(--padding-horizontal) * 0.96);
  }

  @media ${maxD.laptop} {
    padding: calc(var(--padding-vertical) * 0.85)
      calc(var(--padding-horizontal) * 0.85);
  }
`

export { Button }
